'use strict';

module.exports = (app) => app.controller('feSourcingWaiverCtrl', /* @ngInject */ function ($scope, $attrs, $http, feSourcingWaiverService, $filter) {
	$scope.basketId = "";
	$scope.error = false;
	$scope.loading = false;
	$scope.user = null;
	$scope.sourcingWaiverIsNecessary = false;
	$scope.sourcingWaiver = null;
	$scope.customerId = "";
	$scope.hrefSendDisable = false;
	$scope.requestInProgress = false;
	$scope.editSourcingWaiver = true;

	$scope.minimumAmountOfAlternatives = null;
	$scope.priceLimit = null;
	$scope.currentPrice = null;
	$scope.currentNumberOfOffers = null;

	let btnSendFormId = '';
	let btnSendFormDomEl = null;

	/**
	 * Initialise all required variables.
	 * @param basketId
	 * @param customerId
	 * @param btnSendId
	 */
	$scope.initSourcingWaiver = function (basketId, customerId, btnSendId) {
		$scope.loading = true;
		$scope.error = false;
		$scope.basketId = basketId;
		$scope.customerId = customerId;
		btnSendFormId = btnSendId;
		getSourcingWaiverResult().then(() => {
			$scope.loading = false;
			$scope.$apply();
		}, (error) => {
			console.error(error);
			$scope.error = true;
		})

	};

	$scope.editAgain = () => {
		setNecessary(true);
		$scope.editSourcingWaiver = true;
	};

	/**
	 * This function is responsible for send a sourcing waiver for the backend to persist this info.
	 */
	$scope.sendSourcingWaiver = function () {
		if ($scope.sourcingWaiver.comment && !$scope.requestInProgress) {
			$scope.requestInProgress = true;
			feSourcingWaiverService.sendSourcingWaiver.create(
				{
					basketId: $scope.basketId,
					comment: $scope.sourcingWaiver.comment,
					customerId: $scope.customerId
				})
				.$promise.then(
				function () {
					setNecessary(false);
					$scope.showTextModules = false;
					$scope.editSourcingWaiver = false;
					$scope.requestInProgress = false;
				}, function (error) {
					console.error(error);
					$scope.error = true;
					$scope.requestInProgress = false;
				}
			);
		}
	};

	function setNecessary(isNecessary){
		$scope.sourcingWaiverIsNecessary = isNecessary;
		if(isNecessary && btnSendFormDomEl === null && !!document.getElementById(btnSendFormId)){
			btnSendFormDomEl = document.getElementById(btnSendFormId);
			btnSendFormDomEl.remove();
		} else if (!isNecessary && btnSendFormDomEl !== null){
			const buttonContainer = document.getElementById('btnSendContainer');
			buttonContainer.appendChild(btnSendFormDomEl);
			btnSendFormDomEl = null;
		}
	}

	/**
	 * Check if the sourcing waiver needed for current order or not.
	 */
	function getSourcingWaiverResult() {
		return new Promise((resolve, reject) => {
			feSourcingWaiverService.checkIfSourcingWaiverIsNecessary.query(
				{
					basketId: $scope.basketId
				})
				.$promise.then(
				async function ({currencyIso, minimumAmountOfAlternatives, priceLimit, result, currentPrice, currentNumberOfAlternatives}) {
					$scope.minimumAmountOfAlternatives = minimumAmountOfAlternatives;
					$scope.priceLimit = $filter('currency')(priceLimit, currencyIso, 2);
					$scope.currentPrice = $filter('currency')(currentPrice, currencyIso, 2);
					$scope.currentNumberOfOffers = currentNumberOfAlternatives + 1;
					if (result === 'NECESSARY') {
						try {
							await $scope.getSourcingWaiverForBasket();
							resolve();
						} catch (error) {
							reject(error);
						}
					} else {
						resolve();
					}
				}, function (error) {
					reject(error);
				}
			);
		});
	}

	/**
	 * Update orderId for special explanation
	 */
	$scope.updateOrderIdForSourcingWaiver = function (basketId, orderId) {
		feSourcingWaiverService.updateOrderIdForSourcingWaiver.update(
			{
				basketId: basketId
			}, orderId)
			.$promise.then(
			function () {
			}, function (error) {
				console.error(error);
			}
		);
	};

	/**
	 * When the sourcing waiver is necessary the possibly existing explanation shall be fetched
	 */
	$scope.getSourcingWaiverForBasket = function () {
		return new Promise(((resolve, reject) => {
			feSourcingWaiverService.getExplanationForBasket.query(
				{
					basketId: $scope.basketId,
				})
				.$promise.then(
				function (result) {
					$scope.sourcingWaiver = {};
					$scope.sourcingWaiver.comment = result.length > 0 ? result[0].comment : '';
					if($scope.sourcingWaiver.comment){
						$scope.editSourcingWaiver = false;
						setNecessary(false);
					} else {
						$scope.editSourcingWaiver = true;
						setNecessary(true);
					}
					$scope.sourcingWaiver.comment ? $scope.editSourcingWaiver = false : $scope.editSourcingWaiver = true;
					resolve();
				}, function (error) {
					reject(error);
				}
			);
		}));
	};

});
